import Vue from 'vue'
import Router from 'vue-router'
import MainPage from '@/views/frame/mainpage'
import Home from '@/views/home/index'
import NOPermission from '@/views/home/nopermission'

/** 财务系统 */
// 账户余额
import Balance from '@/views/balance/balance'
// 充值
import Recharge from '@/views/recharge/recharge'
import Deposit from '@/views/recharge/deposit'
import Success from '@/views/recharge/success'
import Fail from '@/views/recharge/fail'

// 提现
import Withdraw from '@/views/withdraw/withdraw'
// 流水
import Transaction from '@/views/transaction/transaction'
// 账单
import Bill from '@/views/bill/bill'
import QueryBill from '@/views/bill/query'
import CreateBill from '@/views/bill/customerlist'

//用户管理
import User from '@/views/user/user'
import Staff from '@/views/user/staff'
import Jurisdiction from '@/views/user/jurisdiction'

//报表
import Report from '../views/report/report'
import ReportBalance from '../views/report/balance'

import OfflineDeposit from '../views/offlinedeposit/offlinedeposit'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: __dirname,
  routes: [{
    path: '/',
    component: MainPage,
    children: [{
        path: '/',
        name: '信用额度',
        component: Balance
      },{
        path: '/login',
        component: () => import('@/views/login/index'),
        hidden: true
      },
      {
        path: '/recharge',
        name: 'recharge',
        component: Recharge
      },
      {
        path: '/deposit',
        name: 'deposit',
        component: Deposit
      },
      // {path:'/withdraw', name:'提现', component:Withdraw },
      {
        path: '/transaction',
        name: '交易流水',
        component: Transaction
      },
      {
        path: '/bill',
        name: '账单',
        component: Bill,
        children: [{
            path: 'create',
            name: 'create',
            component: CreateBill
          },
          {
            path: 'query',
            name: 'query',
            component: QueryBill
          }
        ]
      },
      {
        path: '/success',
        name: '支付成功',
        component: Success
      },
      {
        path: '/fail',
        name: '支付失败',
        component: Fail
      },
      {
        path: '/nopermission',
        name: '无权限页面',
        component: NOPermission
      },
      {
        path: '/user',
        name: '用户管理',
        component: User,
        children: [{
            path: 'staff',
            name: '内部员工',
            component: Staff
          },
          {
            path: 'jurisdiction',
            name: '权限分配',
            component: Jurisdiction
          }
        ]
      },
      {
        path: '/report',
        name: '报表中心',
        component: Report,
        children: [{
          path: 'balance',
          name: '客户余额',
          component: ReportBalance
        }]
      },
      {
        path: '/offlinedeposit',
        name: '线下充值审核',
        component: OfflineDeposit,
      }
    ]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js